import { parse, isValid } from 'date-fns'

export function useValidate(input, initValue) {
    if (!input) { return }
    let valid = true
    const value = (input.target && input.target.value)
        ? input.target.value
        : (input instanceof Date ? input.toLocaleString('pl-PL') : input)

    let validationErrors = []

    for (let validateRule of initValue.validation) {
        const rule = validateRule.split('::').shift()
        const ruleConf = setArrayIfExists(validateRule.split('::').pop())
        let condition = ''

        switch (rule) {
            //required
            case 'required':
                valid = value.length > 0 && valid
                if (!(value.length > 0)) {
                    validationErrors.push('To pole jest wymagane.')
                }
                break

            //email
            case 'email':
                condition = validateEmail(value)
                valid = condition && valid
                if (!condition) {
                    validationErrors.push('Pole zawiera niepoprawny format email.')
                }
                break

            //isNumber
            case 'number':
                valid = !isNaN(value) && valid
                if (isNaN(value)) {
                    validationErrors.push('Pole powinno zawierać prawidłowy numer.')
                }
                break
            //maxLength:5
            case 'maxLength':
                valid = value.length <= ruleConf && valid
                if (!(value.length <= ruleConf))
                    validationErrors.push(`Maksymalna ilość znaków: ${ruleConf}.`)
                break

            //minLength:5
            case 'minLength':
                valid = value.length >= ruleConf && valid
                if (!(value.length >= ruleConf))
                    validationErrors.push(`Minimalna ilość znaków: ${ruleConf}.`)
                break

            //containsOnly:["John"]
            case 'containsOnly':
                condition = ruleConf.some(rule => rule === value)
                valid = condition && valid
                if (!condition)
                    validationErrors.push(`Pole powinno zawierać tylko jedną z wartości: ${ruleConf.join(', ')}.`)
                break

            //containsAll:["John", "Doe"]
            case 'containsAll':
                condition = ruleConf.every(rule => value.indexOf(rule) !== -1)
                valid = condition && valid
                if (!condition)
                    validationErrors.push(`Pole powinno zawierać wszystkie wartości: ${ruleConf.join(', ')}.`)
                break

            case 'checked':
                valid = input.target.checked && valid
                if (!(input.target.checked)) {
                    validationErrors.push('To pole jest wymagane.')
                }
                break

            case 'date':
                if (value) {
                    const dateValue = parse(value.trim(), 'dd.MM.yyyy', new Date())
                    condition = isValid(dateValue)
                    valid = condition && valid
                    if (!condition) {
                        validationErrors.push('Podaj prawidłową datę urodzenia.')
                    }
                }
                break

            case 'ageBetween':
                valid = false
                const [minValue, maxValue] = ruleConf.split(',')
                if (value) {
                    const [datePart] = value.split(',')
                    const dateValue = parse(datePart.trim(), 'dd.MM.yyyy', new Date())
                    const currentYear = new Date().getFullYear()
                    const minYear = currentYear - (maxValue || 19)
                    const maxYear = currentYear - (minValue || 5)
                    const computedMinDate = new Date(minYear, 0, 1)
                    const computedMaxDate = new Date(maxYear, 11, 31)
                    valid = dateValue >= computedMinDate && dateValue <= computedMaxDate
                }

                if (!valid) {
                    validationErrors.push(`Wiek uczestnika nie spełnia wymagań turnusu (min. ${minValue} lat, maks,. ${maxValue} lat.`)
                }
                break

            default: valid = valid
                break
        }
    }

    //Show initial Validation messages if they exists.
    validationErrors =
        initValue.validationErrors && initValue.validationErrors.length > 0
            ? initValue.validationErrors
            : validationErrors

    return {
        value: input.target ? (input.target.type === 'checkbox' ? input.target.checked : input.target.value) : input,
        validation: {
            isValid: valid,
            errors: validationErrors,
            rules: initValue.validation
        }
    }
}

//Check if validation rule conf is array
function setArrayIfExists(conf) {
    if (conf[0] === '[' && conf[conf.length - 1] === ']') {
        return JSON.parse(conf)
    }

    return conf
}

function validateEmail(email) {
    return /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(email)
}
